import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment';

import createArchiveContainer from '@components/Archive/createArchiveContainer'
import statuses from '@server/constants/statuses/timesheet-statuses'
import { filterPresets } from '@modules/form/form.module'

import { TimesheetModel } from '@modules/timesheet/timesheet.module'

export default createArchiveContainer({
	Model: TimesheetModel,
	title: 'Timesheets',
	showNewLink: false,
	queryConfig: {
		useSearch:false,
		filters: filterPresets([
			['status', {
				options: [
					{ label: 'All', value: 'any' },
					...statuses.map(s => ({
						label: s.label,
						value: s.order,
					})),
				]
			}],
			'client',
			'taxWeek',
		]),
		defaults: {
			sortBy: 'status',
		}
	},
	searchable: false,
	tableConfig: {
		columns: [
			{
				label: 'Status',
				prop: 'status',
				sortKey: 'status',
				getValue: (doc) => doc.status.label,
			},
			{
				label: 'Tax Week',
				prop: 'taxWeek',
				sortKey: 'taxWeek',
			},
			{
				label: 'Week Ending',
				getValue: (doc) => moment(doc.weekEnding).format('DD/MM/YYYY'),
				sortKey: 'weekEnding',
			},
			{
				label: 'Client Name',
				getValue: (doc) => doc.client ? doc.client.label : '',
				sortKey: 'client.clientName',
			},
			{
				label: 'Hours Worked',
				prop: 'totalHours',
				sortKey: 'totalHours'
			},
			{
				label: 'Cost',
				getValue: (doc) => `${doc.totalCost ? `£${doc.totalCost}` : '-'}`,
				sortKey: 'totalCost',
			},

		],
		rowLinks: (doc) => (
			<div>
				<Link className="TableRow-link" to={`timesheet/${doc.id}`}>view</Link>
			</div>
		),
	},
	mapDataToCSV: (data) => {
		const headers = ['Status', 'Tax Week', 'Week Ending', 'Client Name', 'Hours Worked', 'Cost'];

		const totals = data.reduce((t, doc) => {
			return {
				totalHours: t.totalHours + doc.totalHours,
				totalCost: t.totalCost + doc.totalCost,
			}
		}, { totalHours: 0, totalCost: 0 }); 

		const rows = data.map(d => [
			d.status ? d.status.label : '', 
			d.taxWeek,
			d.weekEnding ? moment(d.weekEnding).format('DD/MM/YYYY') : undefined,
			d.client.clientName,
			d.totalHours,
			d.totalCost != null ? `£${d.totalCost}` : undefined,
		])
		
		return [
			headers, 
			...rows, 
			[], [], // leave a couple of rows gap in the CSV
			['Total Hours', totals.totalHours],
			['Total Cost', `£${totals.totalCost}`] 
		];
	},
});




// WEBPACK FOOTER //
// ./src/scenes/Timesheets/TimesheetListContainer.jsx